import API from '@aws-amplify/api'
import { PREFIX } from './config'
import packageJson from '../../package'
export default (functionName, body = {}, method = 'post') => {
    const path = PREFIX + functionName + '/invocations'
    body.clientType = 'WEB_APP'
    body.clientVersion = packageJson.version
    return API[method]('lambda', path, { body })
}
